/*
 * Theaterish Kit (ConvertKit) opt-in handler.
 * Progressive enhancement for any `form[data-th-kit]`: posts to the Kit form
 * endpoint, opens the tripwire in a new tab, and swaps in the sibling
 * `[data-th-kit-success]` card on the page they came from. Without JS the form
 * posts to Kit directly (opens Kit's confirmation). Handles any number of
 * opt-in forms on a page via event delegation; binds once.
 *
 * REDIRECT: Kit's own "redirect to an external page" setting only runs inside
 * Kit's index.js, which these forms never load — they post straight to the API.
 * So the redirect lives here. Default applies to every form; a single form can
 * opt out with an empty data-th-kit-redirect="".
 *
 * ⚠ window.open MUST be called synchronously inside the submit handler. Called
 * from the fetch .then() it is no longer tied to a user gesture and popup
 * blockers kill it silently. Open a blank tab now, point it at the URL later.
 */
(function () {
  if (window.__thKitBound) return;
  window.__thKitBound = true;

  var DEFAULT_REDIRECT = 'https://theaterish.thrivecart.com/show-starter-17/';

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-th-kit]');
    if (!form) return;
    e.preventDefault();

    var email = form.querySelector('[name="email_address"]');
    if (email && !email.value) { email.focus(); return; }

    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');

    var success = form.parentElement && form.parentElement.querySelector('[data-th-kit-success]');

    var redirect = form.hasAttribute('data-th-kit-redirect')
      ? form.getAttribute('data-th-kit-redirect')
      : DEFAULT_REDIRECT;

    // Opened here, while the submit is still a user gesture. null = blocked.
    var win = redirect ? window.open('', '_blank') : null;

    fetch(form.action, { method: 'POST', body: new FormData(form), mode: 'no-cors' })
      .catch(function () {})
      .then(function () {
        if (btn) btn.removeAttribute('aria-busy');

        if (redirect) {
          if (win) {
            win.location.href = redirect;
          } else {
            // Popup blocked — fall back to same-tab so the offer isn't lost.
            window.location.href = redirect;
            return;
          }
        }

        form.hidden = true;
        // Inline display:none guarantees the form hides even when a class rule
        // (e.g. .th-optin__form/.th-fbar__form { display:flex }) would otherwise
        // out-specify the [hidden] attribute and keep it visible.
        form.style.display = 'none';
        if (success) success.hidden = false;
      });
  });
})();